/* eslint react/destructuring-assignment: "off" */
/* eslint react-hooks/exhaustive-deps: "off" */
/* eslint react/require-default-props: "off" */

import { useEffect, useRef, useState } from 'react';
import { Row } from 'react-bootstrap';

import * as tracker from 'common/tracker';
import useInterval from 'hooks/useInterval';

import Tick from 'assets/svg/tick.svg?react';
import CampaignList from 'components/subscribe/property/CampaignList';
import PageHeader from 'components/subscribe/property/PageHeader';

import { PropertyBranding } from 'common/types';

import '../Base-Subscribe.css';
import './Embed-Subscribe.css';

const PropertySuccess = ({ branding }: { branding?: PropertyBranding }) => {
  const [isCountingDown, setCountingDown] = useState(true);
  const [timeRemainingSecs, setTimeRemainingSecs] = useState(3);

  const pageInstanceId = useRef(0);

  useEffect(() => {
    if (branding) {
      /* Generate random nine-digit number starting with non-zero digit */
      pageInstanceId.current = Math.floor(
        100000000 + Math.random() * 900000000
      );
      tracker.track({
        eventName: 'Display Subscription Page',
        trackingParams: {
          'Subscription page displayed to reader': window.location.href,
          '# campaigns offered': branding.orderedCampaigns.length,
          'Page instance ID': pageInstanceId.current,
          'Subscription Page': 'Property',
        },
      });
    }
  }, []);

  useInterval(
    // Callback - code to be executed each interval
    () => {
      if (timeRemainingSecs > 0) {
        setTimeRemainingSecs(timeRemainingSecs - 1);
      } else {
        setCountingDown(false);
        handleRedirect();
      }
    },
    // Interval - return null to stop the interval when the countdown reaches zero
    isCountingDown ? 1000 : null
  );

  const initialSelectedCampaigns = branding?.orderedCampaigns.map(
    campaignURNAndName => ({
      ...campaignURNAndName,
      isSelected: false,
    })
  );

  const [selectedCampaigns, setSelectedCampaigns] = useState(
    initialSelectedCampaigns
  );

  if (!branding) {
    return null;
  }

  const handleRedirect = () => {
    const hasRedirectURL = branding?.redirectURL && branding.redirectURL !== '';
    if (hasRedirectURL) {
      window.location.href = branding.redirectURL;
    }
  };

  const handleSelection = (value: string) => {
    const newSelectedCampaigns = selectedCampaigns?.map(campaign => {
      if (campaign.campaignURN === value) {
        const modifiedCampaign = {
          ...campaign,
          isSelected: !campaign.isSelected,
        };
        return modifiedCampaign;
      }
      return campaign;
    });

    setSelectedCampaigns(newSelectedCampaigns);
  };

  return (
    <>
      <div className="subscribe__page client__specific d-flex flex-column">
        <PageHeader branding={branding} />

        <CampaignList
          campaignList={selectedCampaigns!}
          handleSelection={handleSelection}
        />

        <Row className="subscribe__footer d-flex flex-column align-items-center m-0">
          <div className="subscribe__property__confirmation">
            <Tick />
            <span className="p-2">{branding.confirmationTitleCopy}</span>
          </div>
          <div className="subscribe__content__privacy mt-2">
            {branding.confirmationBodyCopy}
          </div>
        </Row>
      </div>
    </>
  );
};

export default PropertySuccess;
